import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import { FileTriageData } from '../../../interfaces/fileTriage.interface';
import { CommonModule } from '@angular/common';
import { ListService } from '../../../shared/services/list.service';
import { UserService } from '../../../services/user.service';
import { TimesheetFilterComponent } from '../../payroll/timesheets/timesheet-filter/timesheet-filter.component';

@Component({
  selector: 'ppl-payroll-nat-pay-detail',
  standalone: true,
  imports: [
    ListTableComponent,
    CommonModule,
    TimesheetFilterComponent
  ],
  templateUrl: './payroll-nat-pay-detail.component.html',
  styleUrl: './payroll-nat-pay-detail.component.css',
})
export class PayrollNatPayDetailComponent implements OnInit {
  @Input() selectedRow: any;
  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;

  pageId: string = PAGE_CONSTANTS.PAYLIST_DETAIL_DATA_GRID_PAGE;
  programName!: string;
  columnsToBeHidden: any = [];
  sharedDataKey: string = STATIC_DATA.SHARED_FILE_DETAIL_PAYLIST_DATA;
  actionsToBeHidden: any = [];
  pdfFile?: any;
  pdfConfig: any;
  checkedRows: FileTriageData[] = [];
  paylistdetails: any[] = [];
  paylistdetailsCols = [
    {
      field: "pplproviderid",
      header: "Provider PPL ID",
      jsonpath: "pplproviderid",
      isDisplayedAtHeader: "y",
      isSearchable: "n"
    },
    {
      field: "returncode",
      header: "Return Code",
      jsonpath: "returncode",
      isDisplayedAtHeader: "y",
      isSearchable: "n"
    },
    {
      field: "returndesc",
      header: "Return Description",
      jsonpath: "returndesc",
      isDisplayedAtHeader: "y",
      isSearchable: "n"
    },
    {
      field: "originalaccntnmbr",
      header: "Original Account Number",
      jsonpath: "originalaccntnmbr",
      isDisplayedAtHeader: "y",
      isSearchable: "n"
    },
    {
      field: "originalroutingnmbr",
      header: "Original Account Routing Number",
      jsonpath: "originalroutingnmbr",
      isDisplayedAtHeader: "y",
      isSearchable: "n"
    },
    {
      field: "originalaccounttype",
      header: "Original Account Type",
      jsonpath: "originalaccounttype",
      isDisplayedAtHeader: "y",
      isSearchable: "n"
    },
    {
      field: "newaccntnmbr",
      header: "New Account Number",
      jsonpath: "newaccntnmbr",
      isDisplayedAtHeader: "y",
      isSearchable: "n"
    },
    {
      field: "newroutingnmbr",
      header: "New Account Routing Number",
      jsonpath: "newroutingnmbr",
      isDisplayedAtHeader: "y",
      isSearchable: "n"
    },
    {
      field: "newaccounttype",
      header: "New Account Type",
      jsonpath: "newaccounttype",
      isDisplayedAtHeader: "y",
      isSearchable: "n"
    },
    {
      field: "status",
      header: "Status",
      jsonpath: "status",
      isDisplayedAtHeader: "y",
      isSearchable: "n"
    }
  ];

  fields = [
    { field: 'providerPplId', show: true }
  ];

  constructor(
    public listService: ListService,
    private userService: UserService
  ) { }

  ngOnInit() {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
  }

  ngOnDestory() {
  }

  handleCancel() {
    this.pdfFile = null
  }

  buildRequestPayload(pageName: string, orderBy: string, searchParams: [], startingPageNumber = 1) {
    if (searchParams.length == 0) {
      //handle the error here
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: [],
    };
    return payload;
  }

  loadNatPayDetails(filters: any, startingPageNumber = 1, currentPage = 0) {
    if (startingPageNumber == 1) {
      this.paylistdetails = [];
    }
    const processedPayload = this.buildRequestPayload(
      'natpayfiledetaillist',
      '',
      filters,
      startingPageNumber
    );
    this.listService
      .getListData(processedPayload, 'natpaylist')
      .subscribe((data: any) => {
        const records = data.responsedata;
        if (startingPageNumber > 1) {
          this.paylistdetails = [...this.paylistdetails, ...records];
        } else {
          this.paylistdetails = records;
        }

        if (this.childComponent) {
          this.childComponent.resetPagination(startingPageNumber, currentPage);
        }
      });
  }

  onPageLoad(event: any) {
    let filters = [{
      jsonPath: "natpayfileid",
      value: this.selectedRow.natpayfileid,
      operator: "equal"
    }];

    this.loadNatPayDetails(filters,
      event.startingPageNumber ?? 1,
      event.first ?? 0
    );
  }

  onSearch(event: any) {
    const filters = [{
      jsonPath: "natpayfileid",
      value: this.selectedRow.natpayfileid,
      operator: "equal"
    }];

    if (event.providerPplId && event.providerPplId.trim()) {
      filters.push({
        jsonPath: "pplproviderid",
        value: event.providerPplId.trim(),
        operator: "Equal"
      });
    }

    this.loadNatPayDetails(filters);
  }
}